import { useEffect, useState } from "react";
import axios from "axios";
import { API, authHeaders } from "../loads/common";

let cache = null;
let pending = null;

/** Company profiles (`GET /auth/companies/`) indexed by owner user id: verified flag, email, address, documents… */
const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = axios
      .get(`${API}/auth/companies/`, { headers: authHeaders() })
      .then((r) => {
        const by = {};
        const names = {};
        const rows = Array.isArray(r.data) ? r.data : r.data?.results || [];
        for (const c of rows) {
          if (c.owner_id != null) by[String(c.owner_id)] = c;
          const n = String(c.company_name || "").trim().toLowerCase();
          if (n && !names[n]) names[n] = c;
        }
        // non-enumerable helpers keep `byOwner` a plain id → profile map
        Object.defineProperty(by, "_names", { value: names });
        Object.defineProperty(by, "_all", { value: rows });
        cache = by;
        return by;
      })
      .catch(() => ({}))
      .finally(() => {
        pending = null;
      });
  }
  return pending;
};

/**
 * `useCompanies()` → `{ byOwner: {ownerId: profile}, byName: {lower-cased company_name: profile}, all: [profile] }`;
 * empty until loaded (and on error).
 */
export default function useCompanies() {
  const [byOwner, setBy] = useState(cache || {});
  useEffect(() => {
    let live = true;
    load().then((m) => live && setBy(m));
    return () => {
      live = false;
    };
  }, []);
  return { byOwner, byName: byOwner._names || {}, all: byOwner._all || [] };
}
